'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(GamingLimitType2) {
  GamingLimitType2[GamingLimitType2["DEPOSIT"] = 1] = "DEPOSIT";
  GamingLimitType2[GamingLimitType2["WAGERING_CASINO"] = 2] = "WAGERING_CASINO";
  GamingLimitType2[GamingLimitType2["NET_LOSS_CASINO"] = 3] = "NET_LOSS_CASINO";
  GamingLimitType2[GamingLimitType2["WAGERING_SPORTS"] = 4] = "WAGERING_SPORTS";
  GamingLimitType2[GamingLimitType2["NET_LOSS_SPORTS"] = 5] = "NET_LOSS_SPORTS";
  GamingLimitType2[GamingLimitType2["SESSION"] = 6] = "SESSION";
  GamingLimitType2[GamingLimitType2["STAKE_PER_SESSION"] = 7] = "STAKE_PER_SESSION";
  GamingLimitType2[GamingLimitType2["MAX_STAKE_PER_BET"] = 8] = "MAX_STAKE_PER_BET";
  GamingLimitType2[GamingLimitType2["NET_LOSS"] = 9] = "NET_LOSS";
  GamingLimitType2[GamingLimitType2["WAGERING"] = 10] = "WAGERING";
})(exports.GamingLimitType || (exports.GamingLimitType = {}));
(function(GamingLimitDuration2) {
  GamingLimitDuration2[GamingLimitDuration2["ONE_DAY"] = 1] = "ONE_DAY";
  GamingLimitDuration2[GamingLimitDuration2["ONE_WEEK"] = 2] = "ONE_WEEK";
  GamingLimitDuration2[GamingLimitDuration2["ONE_MONTH"] = 3] = "ONE_MONTH";
  GamingLimitDuration2[GamingLimitDuration2["THREE_MONTHS"] = 4] = "THREE_MONTHS";
  GamingLimitDuration2[GamingLimitDuration2["NONE"] = 5] = "NONE";
  GamingLimitDuration2[GamingLimitDuration2["SESSION"] = 6] = "SESSION";
})(exports.GamingLimitDuration || (exports.GamingLimitDuration = {}));
